import { FC, useEffect, useState } from 'react';
import { ColumnsType } from 'antd/lib/table';
import { IPaymentSchedule } from '../../models/payment.model';
import { AddComma, getPaymentScheduleDate, isFirstLesson, paymentUserCheck } from '../../libs/helper';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/rootReducer';
import { Button, Table } from 'antd';
import { Link } from 'react-router-dom';
import { tableStyle } from '../../style/antdCssProperty';
import { ScheduleType } from '../../models/Enum';
import { setCreditTotal } from '../../store/payment.slice';

interface IProps {
  onDelete(paymentScheduleId: number): void;
}

const Student2HourCancelTable: FC<IProps> = ({ onDelete }) => {
  const dispatch = useDispatch();

  const { user } = useSelector((root: RootState) => root.authState);
  const { tutorPayment, paymentSchedule } = useSelector((root: RootState) => root.paymentState);

  const [filterSchedule, setFilterSchedule] = useState<IPaymentSchedule[]>([]);

  useEffect(() => {
    const newFilterSchedule = paymentSchedule.filter(({ scheduleType }) => scheduleType === ScheduleType.STUDENT_2HOUR_CANCEL);
    setFilterSchedule(newFilterSchedule);
    if (tutorPayment) {
      dispatch(setCreditTotal({ student2HourCancel: newFilterSchedule.length * 4 }));
    }
  }, [dispatch, tutorPayment, paymentSchedule]);

  const columns: ColumnsType<IPaymentSchedule> = [
    {
      title: '수업시간',
      key: 'startDateTime',
      render: (value, { startDateTime }) => getPaymentScheduleDate(startDateTime),
    },
    {
      title: '학생',
      key: 'student',
      render: (value, { student: { name, id } }) => `${name}(${id})`,
    },
    {
      title: '코스/차지',
      key: 'episode',
      render: (value, { episode: { name, pageNo } }) => `${name} - Lesson ${isFirstLesson(pageNo)}`,
    },
    {
      title: '단가',
      key: 'pay',
      render: () => `$${(4).toFixed(2)}`,
    },
    {
      title: '',
      render: (value, { id }) => <Button type='primary' onClick={() => onDelete(id)}
                                         disabled={tutorPayment?.paymentMaster.isPublished || user === null || paymentUserCheck(user.id)}>삭제</Button>,
    },
    {
      title: '',
      render: (value, { scheduleId }) => <Link to={`/dashboard/${scheduleId}`}><Button
        type='primary'>이동</Button></Link>,
    },
  ];

  const summary = (pageData: IPaymentSchedule[]) => (
    <Table.Summary.Row>
      <Table.Summary.Cell align='center' index={0} colSpan={3}>총 {pageData.length}건</Table.Summary.Cell>
      <Table.Summary.Cell align='center' index={1}
                          colSpan={2}>{tutorPayment ? `$${AddComma(4 * pageData.length, true)}` : 0}</Table.Summary.Cell>
    </Table.Summary.Row>
  );

  return (
    <Table
      style={{ ...tableStyle, marginTop: '1.5rem' }}
      dataSource={filterSchedule}
      columns={columns}
      size='small'
      rowKey='id'
      pagination={false}
      title={() => 'Student 2-hour Cancellation'}
      summary={summary}
    />
  );
};

export default Student2HourCancelTable;
